import axios from 'axios'
import { baseUrl } from './config'

const md5 = require('md5')

function toMd5 (obj, key) {
  return md5(btoa(JSON.stringify(obj)) + key)
}
export function signIn (param, key) {
  const formData = new FormData()
  formData.append('email', param.email)
  formData.append('password', param.password)
  return axios.post(`${baseUrl}/admin/login-email`, formData, {
    headers: {
      'x-signature': toMd5(param, key)
    }
  })
}

export function signOut (param) {
  return axios.post(`${baseUrl}/logout`)
}

export function getAuthUser () {
  return axios.get(`${baseUrl}/users/me`)
}


